import React from 'react'

const OurTeam = () => {
  return (
    <div>OurTeam</div>
  )
}

export default OurTeam